import React from 'react';

import { Text } from '@wix/wix-ui-tpa';
import { useTranslation } from '@wix/yoshi-flow-editor';

import WhatsAppIconGreen from '@/assets/icons/whatsapp-icon-green.svg';

import { st, classes } from './WhatsAppSocialButtonPayload.st.css';

export const WhatsAppSocialButtonPayload: React.FC<{
  infoText?: null | string;
  url?: null | string;
}> = ({ infoText, url }) => {
  const { t } = useTranslation();

  return (
    <div className={st(classes.wrapper)}>
      {infoText && <Text>{infoText}</Text>}
      <a
        className={st(classes.button)}
        href={url ?? undefined}
        target="_blank"
        rel="noreferrer"
      >
        <WhatsAppIconGreen className={st(classes.icon)} />
        {t('app.widget.socialButtons.whatsapp.openButton')}
      </a>
    </div>
  );
};
